enum CartStatus {
  Sleeping = 202,
  Active = 200,
  Empty = 204
}

enum ProductType {
  Service = 'Service',
  InVehicleApp = 'InVehicleApp',
  ThirdPartySolution = '3rd Party Solution',
  DataService = 'DataService'
}

export { CartStatus, ProductType }
